import type { MouseEvent } from "react";
import { useRef } from "react";
import type { ChatMentionProduct } from "./chatMentionUtil";

type Props = {
  product: ChatMentionProduct;
  label: string;
  onActivate: (product: ChatMentionProduct) => void;
};

/** 群聊 @产品按钮（与 PDF 卡片同套路，勿用 display:inline 的匿名 createElement） */
export function ChatMentionProductButton(props: Props): JSX.Element {
  const { product, label, onActivate } = props;
  const lockRef = useRef(false);

  const activate = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (lockRef.current) return;
    lockRef.current = true;
    window.setTimeout(() => {
      lockRef.current = false;
    }, 300);
    onActivate(product);
  };

  const kind = product.productKind?.trim();
  return (
    <button
      type="button"
      className="h5-crm-chat-mention h5-crm-chat-mention--product"
      data-space-product-id={product.spaceProductId.trim()}
      data-display-name={product.displayName.trim()}
      {...(kind ? { "data-product-kind": kind } : {})}
      onClick={activate}
    >
      {label}
    </button>
  );
}
